import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook that scrolls the page to the top when the route changes
 * This ensures that when navigating between pages, the user always starts at the top
 */
export function useScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Force scroll to top with both methods to ensure it works across browsers
    window.scrollTo(0, 0);
    
    // Also use smooth scrolling for better UX
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }, 0);
  }, [pathname]);
}

// Also include default export
export default useScrollToTop; 